import api from './api';

// Inventory API service functions
export interface InventoryProduct {
  productId: string;
  productNo: string;
  productName: string;
  category: string;
  unit: string;
  mrp: number;
  openingStock: number;
  purchase: number;
  sales: number;
  closingStock: number;
  rate: number;
  openingStockRs: number;
  purchaseRs: number;
  salesRs: number;
  closingStockRs: number;
  hasInventory: boolean;
  entryId: string | null;
}

export interface InventoryTableData {
  success: boolean;
  date: string;
  brand1: string;
  brand2: string;
  table1: {
    title: string;
    company: string;
    headers: string[];
    rows: any[];
  };
  table2: {
    title: string;
    company: string;
    headers: string[];
    rows: any[];
  };
  table3: {
    title: string;
    company: string;
    headers: string[];
    rows: any[];
  };
  summary: {
    totalProducts: number;
    aquafitProducts: number;
    cablefitProducts: number;
    entriesWithData: number;
  };
}

export interface SearchParams {
  method?: 'filter' | 'direct';
  category?: string;
  query?: string;
  date?: string;
}

export interface UpdatePurchaseSalesParams {
  productNo: string;
  date: string;
  purchase: number;
  sales: number;
  rate?: number;
}

export interface UpdateRateParams {
  productId: string;
  rate: number;
  date?: string;
  updateAllEntries?: boolean;
}

export interface BulkUpdateParams {
  date: string;
  updates: Array<{
    type: 'purchase_sales' | 'rate';
    productNo?: string;
    productId?: string;
    purchase?: number;
    sales?: number;
    rate?: number;
  }>;
}

// Get inventory tables data
export const getInventoryTables = async (params: {
  date?: string;
  brand1?: string;
  brand2?: string;
}): Promise<InventoryTableData> => {
  const response = await api.get('/inventory/tables', { params });
  return response.data;
};

// Search inventory products
export const searchInventoryProducts = async (params: SearchParams) => {
  const response = await api.get('/inventory/search', { params });
  return response.data;
};

// Update purchase and sales (Table 1 editing)
export const updatePurchaseSales = async (params: UpdatePurchaseSalesParams) => {
  const response = await api.put('/inventory/purchase-sales', params);
  return response.data;
};

// Update product rate (Table 3 editing)
export const updateProductRate = async (params: UpdateRateParams) => {
  const response = await api.put('/inventory/rate', params);
  return response.data;
};

// Bulk update inventory table
export const bulkUpdateInventoryTable = async (params: BulkUpdateParams) => {
  const response = await api.put('/inventory/bulk-update', params);
  return response.data;
};

// Get available brands
export const getAvailableBrands = async () => {
  const response = await api.get('/inventory/brands');
  return response.data;
};

// Get inventory report
export const getInventoryReport = async (params: {
  period?: string;
  date?: string;
  categoryId?: string;
  brand?: string;
}) => {
  const response = await api.get('/inventory/report', { params });
  return response.data;
};

// Download inventory Excel
export const downloadInventoryExcel = async (params: {
  period?: string;
  date?: string;
}) => {
  const response = await api.get('/inventory/download/excel', { 
    params,
    responseType: 'blob'
  });
  return response;
};
